import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"

Vue.use(VueRouter)
console.log('[BUILD]', process.env.VUE_APP_BUILD || Date.now());

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',
    children: [
      // ── Data Management ─────────────────────────────────────────
      { path: 'home',
        name: 'Home Page',
        component: () => import('../views/Home.vue'),
        meta: { section: 'Data Management', title: 'Home Page' }
      },
      { path: 'notice',
        name: 'System Notice',
        component: () => import('../views/Notice.vue'),
        meta: { section: 'Data Management', title: 'System Notice' }
      },
      { path: 'noticeDetails',
        name: 'System Notice Details',
        component: () => import('../views/detailsPage/NoticeDetails.vue'),
        props: r => ({ id: r.query.id || r.params.id }),
        meta: { section: 'Data Management', title: 'System Notice Details' }
      },
      { path: 'owner',
        name: 'Owner Info',
        component: () => import('../views/Owner.vue'),
        meta: {
          section: 'Data Management',
          title: 'Owner Info',
          manageTarget: '/owner',
          visualiseTarget: '/analytics/workflow'
        }
      },
      {
        path: '/monitoring',
        name: 'Monitoring',
        component: () => import('@/views/Monitoring.vue')
      },
      { path: 'ink',
        name: 'Printing Info',
        component: () => import('../views/Ink.vue'),
        meta: {
          section: 'Data Management',
          title: 'Printing Info',
          manageTarget: '/ink',
          visualiseTarget: '/analytics/workflow'
        }
      },
      {
        path: "/formulation/create",
        redirect: "/ink/create"
      },
      {
        path: "/formulation/detail/:id",
        redirect: to => `/ink/detail/${to.params.id}`
      },
      { path: 'materials',
        name: 'Materials Info',
        component: () => import('../views/Materials.vue'),
        meta: {
          section: 'Data Management',
          title: 'Materials Info',
          manageTarget: '/materials',
          visualiseTarget: '/analytics/workflow'
        }
      },
      { path: 'materials/details/:id',
        name: 'MaterialsDetails',
        component: () => import('../views/detailsPage/MaterialsDetails.vue'),
        props: route => ({ id: Number(route.params.id) }),
        meta: { section: 'Data Management', title: 'Materials Details' }
      },
      {
        path: '/materials/monomer-library',
        name: 'MonomerLibrary',
        component: () => import('@/views/detailsPage/MonomerLibrary.vue'),
        meta: { title: 'Monomer Library' }
      },
      { path: 'viscosity',
        name: 'Viscosity',
        component: () => import('../views/Viscosity.vue'),
        meta: {
          section: 'Data Management',
          title: 'Viscosity (Data Entry)',
          manageTarget: '/viscosity',
          visualiseTarget: '/viscositySummary'
        }
      },
      { path: 'viscosityCreate',
        name: 'Viscosity Create',
        component: () => import('../views/detailsPage/ViscosityTestCreate.vue'),
        meta: { section: 'Data Management', title: 'Viscosity — Create Test' }
      },
      { path: 'analytics/workflow',
        name: 'WalkPathGraph',
        component: () => import('../views/analytics/WalkPathGraph.vue'),
        meta: {
          section: 'Data Visualisation',
          title: 'Walk Path Graph',
          manageTarget: '/ink',
          visualiseTarget: '/analytics/workflow'
        }
      },
      { path: 'ink/details/:id',
        name: 'InkDetails',
        component: () => import('../views/detailsPage/InkDetails.vue'),
        props: route => ({ id: Number(route.params.id) }),
        meta: { section: 'Data Management', title: 'Ink Details' }
      },
      { path: 'ink/create',
        name: 'InkCreate',
        component: () => import('../views/detailsPage/InkDetails.vue'),
        meta: { section: 'Data Management', title: 'Ink — Create' }
      },
      { path: 'analytics/workflow',
        name: 'WalkPathGraph',
        component: () => import('../views/analytics/WalkPathGraph.vue'),
        meta: {
          section: 'Data Visualisation',
          title: 'Walk Path Graph',
          manageTarget: '/ink',
          visualiseTarget: '/analytics/workflow'
        }
      },
      // ── Data Visualisation ──────────────────────────────────────
      { path: 'viscositySummary',
        name: 'Viscosity Summary',
        component: () => import('../views/ViscositySummary.vue'),
        meta: {
          section: 'Data Visualisation',
          title: 'Viscosity — Averages & Notes',
          manageTarget: '/viscosity',
          visualiseTarget: '/viscositySummary'
        }
      },
      { path: 'highThroViscosity',
        name: 'High-Throughput Viscosity',
        component: () => import('../views/HighThroViscosity.vue'),
        meta: {
          section: 'Data Visualisation',
          title: 'High-Throughput Viscosity',
          manageTarget: '/viscosity',
          visualiseTarget: '/highThroViscosity'
        }
      },
      { path: 'solubilitySim',
        name: 'Solubility Simulation',
        component: () => import('../views/SolubilitySim.vue'),
        meta: {
          section: 'Data Visualisation',
          title: 'Solubility Simulation',
          manageTarget: '/materials',
          visualiseTarget: '/solubilitySim'
        }
      },

      // 404 inside layout
      { path: '404',
        name: '404',
        component: () => import('../views/404.vue'),
        meta: { section: 'Data Management', title: 'Not Found' }
      },
    ],
  },

  // Outside layout
  { path: '/about', name: 'About',
    component: () => import('../views/AboutView.vue')
  },
  { path: '/signin', name: 'Signin', component: () => import('../views/Signin.vue') },
  { path: '/register', name: 'Register', component: () => import('../views/Register.vue') },
  { path: '/forgot-password', name: 'ForgotPassword', component: () => import('../views/ForgotPassword.vue')},
  { path: '/403', name: 'Auth', component: () => import('../views/Auth.vue') },

  // Optional section landings (nice for header pills if you ever make them clickable)
  { path: '/manage', redirect: '/ink' },
  { path: '/visualise', redirect: '/analytics/workflow' },

  // Catch-all to your layout 404
  { path: '*', redirect: '/404' },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
})


// Keep store title in sync (optional, harmless if no store)
router.afterEach((to) => {
  const title = to.meta && to.meta.title;
  const app   = router.app;
  const store = app && app.$store;
  // set page title
  if (title) document.title = title;
  // commit only if the mutation exists
  if (store && store._mutations && store._mutations['setCurrentPathName']) {
    store.commit('setCurrentPathName', title || to.name || '');
  }
  // also keep localStorage
  localStorage.setItem('currentPathName', to.name || '');
});
const PUBLIC = new Set(['/signin', '/register', '/forgot-password', '/404']);
//guard of router

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');

  // 1) Public pages: allow immediately (but keep authed users out)
  if (PUBLIC.has(to.path)) {
    return token
        ? next({ path: '/home', replace: true })
        : next();
  }

  // 2) Private pages: require token
  if (!token) {
    return next({ path: '/signin', replace: true });
  }

  // 3) Normal case
  next();
});

// Do non-navigation side effects AFTER navigation:
router.afterEach((to) => {
  localStorage.setItem('currentPathName', to.name || '');
  // store.commit('setPath');
});


export default router;
